export default "__VITE_ASSET__694b3100__$_?component__"